import React, { useCallback, useMemo, useRef, useState } from "react";
import { ThemeProvider } from "@mui/material";
import { useIdleTimer } from "react-idle-timer";
import { MultiStepContextLayout, MultiSteps, MultiStepsStep, Themes, useMultiStep } from "@fac/standard-ui-lib";
import Page, { LogoContainer } from "./App.styles";
import GreetingsStep from "./components/GreetingsStep";
import CompanyStep from "./components/CompanyStep/CompanyStep.components";
import ClientContextLayout from "./modules/Client/Client.context";
import Client from "./modules/Client/Client.type";
import ClientStep from "./components/ClientStep";
import FinishStep from "./components/FinishStep/FinishStep.component";
import PendenciesStep from "./components/PendenciesStep/PendenciesStep.component";
import { restart } from "./utils/utils";
import { pdfjs, Document, Page as PdfPAge } from "react-pdf";

//pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//    "pdfjs-dist/build/pdf.worker.min.mjs",
//    import.meta.url,
//).toString();

pdfjs.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.mjs"

const App = () => {
    const multiRef = useRef<HTMLDivElement>(null);
    const { nextStep, presvStep, setStateProps, setStep, stateProps, step, transitionTime } =
        useMultiStep({
            transitionTime: 400,
            maxSteps: 5,
        });

    const [client, setClient] = useState<Client | undefined>({});
    const clientContextValue = useMemo(() => ({ client, setClient }), [client, setClient]);

    const multiStepContextValue = useMemo(
        () => ({
            nextStep,
            presvStep,
            setStateProps,
            setStep,
            stateProps,
            step,
            transitionTime,
        }),
        [nextStep, presvStep, setStateProps, setStep, stateProps, step, transitionTime],
    );

    useIdleTimer({
        timeout: 1000 * 60 * 60 * 2,
        onIdle: () => {
            if (step === 0) return;
            restart();
        },
    });

    const onNextStep: React.MouseEventHandler<HTMLDivElement> = (e) => {
        e?.preventDefault();
        nextStep();
    };


    const [numPages, setNumPages] = useState<number>();
    const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);
    const [containerWidth, setContainerWidth] = useState<number>();
    // pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    //     "pdfjs-dist/build/pdf.worker.min.mjs",
    //     import.meta.url,
    // ).toString();


    const onResize = useCallback<ResizeObserverCallback>((entries) => {
        const [entry] = entries;
        
        if (entry) {
            setContainerWidth(entry.contentRect.width);
        }
    }, []);
    

    return (
        <ThemeProvider theme={Themes.StandardTheme.dark}>
            <ClientContextLayout.Provider value={clientContextValue}>
                <MultiStepContextLayout.Provider value={multiStepContextValue}>
                    <Page id="App">
                        <LogoContainer>
                            <img src={`${process.env.F}/logo.png`} alt="" />
                        </LogoContainer>

                        <MultiSteps
                            ref={multiRef}
                            className="multi-step"
                            nextStep={nextStep}
                            presvStep={presvStep}
                            setStateProps={setStateProps}
                            setStep={setStep}
                            stateProps={stateProps}
                            step={step}
                            transitionTime={transitionTime}
                            sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <MultiStepsStep>
                                <GreetingsStep onClick={onNextStep} role="button" tabIndex={0} />
                            </MultiStepsStep>
                            <MultiStepsStep>
                                <CompanyStep />
                            </MultiStepsStep>
                            <MultiStepsStep>
                                <ClientStep />
                            </MultiStepsStep>
                            <MultiStepsStep>
                                <PendenciesStep />
                            </MultiStepsStep>
                            <MultiStepsStep>
                                <FinishStep />
                            </MultiStepsStep>
                        </MultiSteps>
                    </Page>
                </MultiStepContextLayout.Provider>
            </ClientContextLayout.Provider>
        </ThemeProvider>
    );
};

export default App;
